import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgCalendarSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M5 1V4M11 1V4M14 7.5H2M2 15V4H14V12C14 12.7956 13.6839 13.5587 13.1213 14.1213C12.5587 14.6839 11.7956 15 11 15H2Z"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgCalendarSmall.displayName = 'SvgCalendarSmall';
const CalendarSmall = withForgeIconProps(SvgCalendarSmall, {
  name: 'Calendar',
  usage: 'Use to indicate or edit a date, like in DatePicker.',
  related: 'schedule, reschedule, appointment, time, month, year',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default CalendarSmall;
